<template>
  <div 
    class="flex-column flex-grid--full align-center header__bg__200"
    :style = "cssVar"
  >
    <div>
      <h1 v-if="blogTitle !== ''" class="blog-white">
        <span v-html=blogTitle></span>
      </h1>
      <h3 v-if="blogBullets !== ''" class="intro_bullet">
        <span v-html=blogBullets></span>
      </h3>
      <h2 v-if="blogSubTitle !== ''" class="intro">
        <span v-html=blogSubTitle></span>
      </h2>
    </div>
  </div>
</template>

<script>

export default {
  name: "BlogHeader",
  components: {
  },
  props: {
    blogTitle: {
      type: String,
      required: false
    },    
    blogSubTitle: {
      type: String,
      required: false
    },
    blogBullets: {
      type: String,
      required: false,
    },      
    height: {
      type: String,
      required: false,
      default: "header__bg"
    },    
    AssetHeader: {
      type: String,
      required: false,
    },
    collorHeader: {
      type: String,
      required: false,
    }
  },
  computed: {
    cssVar() {
      return 'background-image: url(' + this.AssetHeader +'); ' + 'min-height: ' + this.height + '; background-color:' + this.collorHeader; 
    }
  }
};
</script>

<style scoped>

.blog-white {
  margin-top: 8%;
  color: #fff;
  text-transform: uppercase;
}

.intro {
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 1.2;
  margin: 8% 0 8% 0;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
}

.intro_bullet {
  font-size: 1.2rem;
  font-weight: 250;
  line-height: 1.25;
  margin: 2% 0 0 0;
  color: #fff;
}

.blog-intro {
  margin-top: 64px;

}

font-awesome-icon {
  font-size: 48px;
}

.container--stretch {
  align-items: stretch;
}

.coll-2--full {
  flex-basis: 50%;
  padding: 20px 50px;
  position: relative;
  height: 100vh;
  display: flex;
  justify-content: center;
}

.content:not(:last-child) {
  margin-bottom: 64px;
}

.coll-2--full p {
  font-size: 20px;
  margin-bottom: 20px;
}

.image {
  position: absolute;
  left: 0;
  bottom: 120px;
  z-index: 0;
}

.step__title {
  font-size: 32px;
  display: inline-block;
  margin-left: 24px;
}

.st0 {
  fill: transparent;
}

.box p {
  font-size: 16px;
  color: #fff;
  text-transform: uppercase;
}

.box:not(:first-of-type) {
  border-left: 1px solid #fff;
}

.header__bg__200 {
  background-position: 50% 45%;
  background-size: cover;
  background-color: rgba(74,144,226,1);
  width: 100%;
  height: 100%;
  margin-bottom: 64px;
}

@media screen and (min-width: 1024px) {

}

.flex-grid {
  padding-bottom: 64px;
}

.slide-leave-active {
  transition: 0.25s cubic-bezier(0, 0, 0.2, 1);
}

.slide-enter-active {
  transition: 0.3s cubic-bezier(0, 0, 0.2, 1) 0.1s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(100%, 0);
}

@media (min-width: 240px) and (max-width: 720px) {
  h1 {
    text-align: center;
  }
  blog-white {
      text-align: center;
  }
  .coll-2--full {
    flex-basis: 100%;
  }
  .content {
    margin-bottom: 20px;
  }

  .image {
    bottom: 0;
  }
  .second {
    order: 2;
  }
  .first {
    order: 1;
  }

  .flex-grid {
    margin: 0 2%;
    padding-bottom: 32px;
  }
}
</style>
